import { Duration } from 'luxon';
import { JobFilters } from 'planning-portal-library/src/lib/core/domain';
import { Mapper } from '../../../../../core/base';
import { JobFiltersWebEntity } from './job-filters-web-entity';
import { isDataSource } from '@angular/cdk/collections';

export class JobFilterWebRepositoryMapper extends Mapper<JobFiltersWebEntity, JobFilters> {
  mapFrom(param: JobFiltersWebEntity): JobFilters {
    return {
      id: param.id,
      startTerminalLatitude: param.startTerminalLatitude,
      startTerminalLongitude: param.startTerminalLongitude,
      endTerminalLatitude: param.endTerminalLatitude,
      endTerminalLongitude: param.endTerminalLongitude,
      startTime: param.startTime ,
      endTime: param.endTime,
      startTerminalName: param.startTerminalName,
      endTerminalName: param.endTerminalName,
      jobTemplate  : param.jobTemplate,
      maxLocations : param.maxLocations,
      isFullDay : param.isFullDay,
    };
  }

  mapTo(param: JobFilters): JobFiltersWebEntity {
    return {
        id: param.id,
        startTerminalLatitude: param.startTerminalLatitude,
        startTerminalLongitude: param.startTerminalLongitude,
        endTerminalLatitude: param.endTerminalLatitude,
        endTerminalLongitude: param.endTerminalLongitude,
        startTime: param.startTime,
        endTime: param.endTime,
        startTerminalName: param.startTerminalName,
        endTerminalName: param.endTerminalName,
        jobTemplate  : param.jobTemplate,
        maxLocations : param.maxLocations,
        isFullDay : param.isFullDay,
    };
  }
}
